module.exports = __webpack_public_path__ + "static/media/salesflyerpic.21272765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/updates 2020/salesflyerpic.jpg
// module id = 37
// module chunks = 0